module.exports = "<div class=modal-header> <h3 class=modal-title>Log into Forge</h3> </div> <div class=modal-body> You are about to be redirected to ForgeLab to authorize your access. Click the button below and follow the instructions. At the end of the autorization procedure you will be redirected to the editor. <br/><br/> <center> <a class=btn href=\"https://forge.etsi.org/gitlab/oauth/authorize?client_id={{gitlabClientId}}&response_type=token&redirect_uri={{gitlabRedirectUri}}&state={{gitlabState}}\">Log into Forge</a> </center> </div>";


//////////////////
// WEBPACK FOOTER
// ./templates/gitlab-oauth.html
// module id = 393
// module chunks = 0